import { createContext } from 'react';
import { authContextInitialState } from './authReducer';
export const authCtx = createContext([authContextInitialState, () => { }]);
